/**
 * 微信授权
 */
import { cbHost, upInfoInSNS } from '../config';
import CheckRegister from '../thirdparty/check';
import Register from '../thirdparty/register';
import notification from 'c-notification';
import UserLogin from '../../profile/login';
import Cache from 'c-cache';
import loading from 'c-up-loading';
import lang from '../../../lang';

const cache = new Cache({
    prefix: 'pcuplive'
});

// 微信 3
const bindType = 3;
const wechat = {
    go() {
        let urlPrefix = 'https://open.weixin.qq.com/connect/qrconnect';
        let result = {
            'appid': upInfoInSNS['wechat'].appId,
            'redirect_uri': cbHost + '/wechat-oauth?type=4',
            'response_type': 'code',
            'scope': 'snsapi_login',
            'state': 'STATE',
            'style': 'white'
        };

        let url = urlPrefix + '?' + $.param(result);

        UP.PrepaireForAsync({ 
            message: lang.template('请稍侯，正在登录中...') ,
            width: 506,
            height: 530
        });

        let wechatWindow = window.open(url);

        let promise = UP.WaitForRecieveMsg(wechatWindow, 'wechatlogin');

        promise.done((code) => {
            if (code) {
                // 成功获取code，code -> acctss_token
                loading.show({
                    content: lang.template('正在登录')
                });
                this.fail = 0;
                this.getWechatGetAccessToken(code);
            }
        });
    },

    getWechatGetAccessToken(code) {
        let promise = $.ajax({
            url: UP.Global.getPyHost() + "/api/account/wechat/token/exchange/",
            data: {
                code: code
            },
            type: 'POST',
            dataType: 'json'
        });

        promise.done((data) => {
            if (data.unionid) {
                let isRegistered = this.checkRegistered(data);

                isRegistered.done((registered) => {
                    if (registered) {
                        // 三方账号已绑定Up直播
                        this.getProfileForRegister(data);
                    } else {
                        // 未绑定
                        this.getProfileForNoRegister(data);
                    }
                });
            } else {
                this.fail++;

                if (this.fail < 3) {
                    this.getWechatGetAccessToken(code)
                } else {
                    loading.hide();
                    notification.simple(lang.template('授权失败'));
                }
            }
        });

        return promise;
    },
    /**
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered(data) {
        let promise = new CheckRegister({
            bindType: bindType,
            thirdId: data.unionid,
            extension: data.openid,
            thirdToken: data.access_token
        }).promise;

        return promise;
    },

    getProfileForNoRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data)=>{
            
            let loginPromise = this.login(data.uid, data.password);
            
            loginPromise.done((data)=>{
                // console.log('用户信息', data);
                loading.hide();
                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);
                
                UP.Global.DA.add({
                    eventName: 'loginSuccess',
                    action: 'show'
                });

                UP.Global.DA.add({
                    eventName: 'wechatLoginSuccess',
                    action: 'click'
                });

                fbq('track', 'LoginSuccess', { oauthtype: 'wechat'});

                $.channel.emit('loginSuccess', data);
            });

            loginPromise.fail((dataWrap)=>{
                loading.hide();
                
                if (dataWrap.code == 4119) {
                    notification.simple('device forbidden');
                }
            })
        });

        registerPromise.fail((dataWrap)=>{
            loading.hide();
            
            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            }
            
        })

    },

    getProfileForRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data)=>{
            // console.log('用户信息', data);
            
            loading.hide();

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            UP.Global.DA.add({
                eventName: 'wechatLoginSuccess',
                action: 'click'
            });

            fbq('track', 'LoginSuccess', { oauthtype: 'wechat'});

            $.channel.emit('loginSuccess', data);
            
        });

        registerPromise.fail((dataWrap)=>{
            loading.hide();
            
            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            }
        })
    },

    register(data) {
        // let _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();
        let promise = new Register({
            bindType: bindType,
            thirdId: data.unionid,
            extension: data.openid,
            thirdToken: data.access_token,
            avatar: encodeURI(data.headimgurl),
            username: data.nickname,
            // countryCode: countryCode
        }).promise;

        return promise;
    },

    login(uid, password) {
        let promise = new UserLogin({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password
        }).promise;

        return promise;
    }
};

export default wechat;



// WEBPACK FOOTER //
// ./js/component/thirdparty-login/wechat/index.js